export const passwordRegexConstant = {
  PASSWORD_REGEX:
    "(?=.*[_!@#$%^&*-/^{#%'*/<()>}:`;,!& .?_$+-])(?!.*[.\n])(?=.*[a-z])(?=.*[0-9])(?=.*[A-Z])^.{6,}$",
};
